import { useTranslation } from "react-i18next";
import { Check } from "../../assets/svgs";
import "./styles.scss";
import useApp from "../../hooks/useApp";
import InfoKeyValueCard from "../InfoKeyValueCard";
import { useEffect } from "react";

const SelectableItemCard = ({
  data = [],
  selectedByDefault = false,
  disableCheckBox = false,
}) => {
  const { t } = useTranslation();
  const { handleCheckBoxToggle, selectedFinanceAssets } = useApp();

  const calculateTotals = () => {
    let total = 0;
    let selectedTotal = 0;
    let totalCount = data.length;
    let selectedCount = selectedFinanceAssets.length;

    // Calculate total of all items
    data.forEach((item) => {
      const amount = Number(item.limitAmount || 0);
      total += amount;
    });

    // Calculate total of selected items
    selectedFinanceAssets.forEach((item) => {
      const amount = Number(item.limitAmount || 0);
      selectedTotal += amount;
    });

    return { total, selectedTotal, totalCount, selectedCount };
  };

  const getValue = (value) => {
    if (!value || (typeof value === "string" && !value.trim())) {
      return "--";
    }
    if (typeof value === "string") {
      if (value.includes("SAR")) {
        const numericString = value.replace(/[^\d.-]/g, "");
        const numericValue = parseFloat(numericString);
        return isNaN(numericValue) ? (
          value
        ) : (
          <div className="saudi-riyal-wrapper">
            <span className="icon-saudi_riyal"></span>
            <span>{numericValue.toLocaleString()}</span>
          </div>
        );
      }
    }
    return value;
  };

  // Check if item is selected
  const isItemSelected = (sequenceNo) => {
    return selectedFinanceAssets.some((item) => item.sequenceNo === sequenceNo);
  };

  useEffect(() => {
    if (selectedByDefault && data?.length) {
      data.forEach((item, index) => {
        handleCheckBoxToggle({
          selectedState: "selectedFinanceAssets",
          selectedItem: { ...item, sequenceNo: index },
          totalItems: data,
          itemState: "fleetFinanceAssets",
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedByDefault]);

  return (
    <>
      {data &&
        data?.map((item, index) => {
          const isChecked = isItemSelected(index);
          return (
            <div className="selectable-item-card" key={index}>
              <div className="selectable-item-card-name-wrapper">
                <span className="selectable-item-card-name">
                  {`${item?.assetBrand || ""} ${item?.assetType || ""}`.trim()}
                </span>
                <span
                  className={`check-box ${isChecked ? "checked" : ""} ${
                    disableCheckBox ? "checked" : ""
                  }`}
                  onClick={() => {
                    if (disableCheckBox && isChecked) return;

                    handleCheckBoxToggle({
                      selectedState: "selectedFinanceAssets",
                      selectedItem: { ...item, sequenceNo: index },
                      totalItems: data,
                      itemState: "fleetFinanceAssets",
                    });
                  }}
                >
                  {isChecked && (
                    <img src={Check} alt="check" className="check-icon" />
                  )}
                </span>
              </div>
              <div className="selectable-item-card-vendor">
                {t("global.vendor")}: {item.vendor || "--"}
              </div>
              <div className="selectable-item-card-amount">
                {getValue(`${item?.limitAmount || 0} ${item?.ccy || "SAR"}`)}
              </div>
            </div>
          );
        })}

      <InfoKeyValueCard
        hasColon={"true"}
        hasGrandTotal={false}
        labelTextColor="neutral-900"
        backgroundColor="neutral-200"
        labelTextSize="16"
        valueTextSize="14"
        data={[
          {
            label: "total_value",
            value: getValue(`SAR ${calculateTotals().total.toLocaleString()}`),
          },
          // {
          //   label: "selected_assets",
          //   value: getValue(
          //     `SAR ${calculateTotals().selectedTotal.toLocaleString()}`
          //   ),
          //   selectedItemCount: getValue(`${calculateTotals().selectedCount}`),
          // },
        ]}
      />
    </>
  );
};

export default SelectableItemCard;
